import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/authStore';
import { TemplateEditor } from '@/features/Curriculum/TemplateEditor';

export const Route = createFileRoute('/admin/curriculum/$templateId')({
  beforeLoad: () => {
    const { isAuthenticated, hasRole } = useAuthStore.getState();
    if (!isAuthenticated || !hasRole('super_admin')) {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: () => {
    const { templateId } = Route.useParams();
    return <TemplateEditor templateId={templateId} />;
  },
});
